module.exports = __webpack_public_path__ + "img/tzsjyzyy.3fa15ab6.png";